import React, { useState } from 'react';
import DeckSteps from './Fields/DeckSteps';
import DeckSize from './Fields/DeckSize';
import DeckRailing from './Fields/DeckRailing';
import Results from './Results';

const initialAppState = {
    loading: false,
    errors: {}
};

const initialFormState = {
    sqft: 0,
    length: 0,
    width: 0,
    steps: false,
    height: 0,
    railing: false
};

function App() {
  const [appState, setAppState] = useState(initialAppState);
  const [formState, setFormState] = useState(initialFormState);
  const [inquiryState, setInquiryState] = useState({
      email: '',
      zip_code: '',
      name: '',
      phone: '',
      comments: '',
      estimates: {},
      levels: {},
      sentRequest: false,
      error: undefined
  });

  const submitHandler = async () => {
    setAppState({
        ...appState,
        errors: {},
        loading: true
    });

    const {
        sqft,
        length,
        width,
        steps,
        height
    } = formState;

    if (!sqft && !(length && width)) {
      setAppState({
          ...appState,
          errors: {
              ...appState.errors,
              'Deck Size': 'Either dimensions or square footage need to be set.'
          }
      });
      return;
    }

    if (steps && !height ) {
      setAppState({
          ...appState,
          errors: {
              ...appState.errors,
              'Deck Steps': 'Deck height is required if steps is checked.'
          }
      });
      return;
    }

      fetch(window.ajaxSettings.ajaxurl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Cache-Control': 'no-cache',
          },
          body: new URLSearchParams({
              ...formState,
              action: 'api_calculate',
              nonce: window.ajaxSettings.nonce,
          }),
      })
          .then(res =>
              (res.ok)
                  ? res.json()
                  : res.json()
                      .then(e => Promise.reject(e))
          )
          .then(res => {
              setAppState({ ...appState, loading: false });
              setInquiryState({ ...inquiryState, levels: res.levels, estimates: res.estimates });
          })
          .catch(e => {
              setAppState({ ...appState, loading: false });
          });
  }

  const onChangeHandler = (value, property) => {
    setFormState({ ...formState, [property]: value});
    setInquiryState({ ...inquiryState, estimates: {}});
    setAppState({ ...appState, errors: {} });
  }

  const onInquiryValueChange = (value, property) => {
    setInquiryState({ ...inquiryState, [property]: value});
  }

  const displayErrors = () => {
    const errors = Object.entries(appState.errors);
    if (errors.length > 0) {
      return (
          <div className="alert alert-warning">
            <ul className="sdc_errors">
              {Object.entries(appState.errors).map(i => (
                  <li className="error">
                    {`${i[1]}`}
                  </li>
              ))}
            </ul>
          </div>
      );
    }
  }

  const onInquirySubmit = (e) => {
      e.preventDefault();

      const grecaptcha = window.grecaptcha;
      const sitekey = window.wpcf7_recaptcha.sitekey;

      if (grecaptcha) {
          grecaptcha.ready(function() {
              grecaptcha.execute(sitekey, {action: 'submit'})
                  .then(function(token) {
                      fetch(window.ajaxSettings.ajaxurl, {
                          method: 'POST',
                          credentials: 'same-origin',
                          headers: {
                              'Content-Type': 'application/x-www-form-urlencoded',
                              'Cache-Control': 'no-cache',
                          },
                          body: new URLSearchParams({
                              name: inquiryState.name,
                              email: inquiryState.email,
                              zip_code: inquiryState.zip_code,
                              phone: inquiryState.phone,
                              comments: inquiryState.comments,
                              deck_sqft: formState.sqft,
                              deck_length: formState.length,
                              deck_width: formState.width,
                              deck_height: formState.height,
                              steps: formState.steps,
                              railing: formState.railing,
                              low_estimate: inquiryState.estimates.low.price.total,
                              med_estimate: inquiryState.estimates.med.price.total,
                              high_estimate: inquiryState.estimates.high.price.total,
                              action: 'api_handle_inquiry',
                              nonce: window.ajaxSettings.nonce,
                              _wpcf7_recaptcha_response: token,
                          }),
                      })
                          .then(res =>
                              (res.ok)
                                  ? res.json()
                                  : res.json()
                                      .then(e => Promise.reject(e))
                          )
                          .then(res => {
                              console.log(res);
                              setInquiryState({ ...inquiryState, sentRequest: true });
                          })
                          .catch(e => {
                              setInquiryState({ ...inquiryState, error: e.message, sentRequest: false });
                          });
                  })
                  .catch(e => {
                      setInquiryState({ ...inquiryState, error: e.message, sentRequest: false });
                  });
          });
      }
  }

  const renderResults = () => {
    if (inquiryState.estimates.hasOwnProperty('low')) {
      return (
          <Results
              estimates={inquiryState.estimates}
              onInquiryValueChange={onInquiryValueChange}
              onInquirySubmit={onInquirySubmit}
              inquirySent={inquiryState.sentRequest}
              form={formState}
              error={inquiryState.error}
          />
      );
    }

    return (
        <div>
          <h3>Get a free estimate.</h3>
          <p>
            Fill out the form fields on the Deck Calculator to get an estimate on your next deck project.
          </p>
        </div>
    );
  }

  return (
      <div className="sdc_wrapper">
        <div className="sdc_inner_wrapper">
          <div className="sdc_calculator_options">
            <fieldset className="sdc_fields">
              <DeckSize onChange={onChangeHandler}/>
              <DeckSteps isChecked={formState.steps} onChange={onChangeHandler}/>
              <DeckRailing onChange={onChangeHandler} isChecked={formState.railing}/>
              <button type="submit" onClick={submitHandler} disabled={ formState.sqft || (formState.width && formState.length) ? false : true }>Calculate</button>
            </fieldset>
          </div>
          <div className="sdc_results">
            {renderResults()}
            {displayErrors()}
          </div>
        </div>
        <div className="disclaimer">
          <p>
            This is only a ballpark calculation, we will need to see the site where the deck will be built to give an exact quote. This calculation does not include any lighting, benches or other upgrades. And does not include removal of any existing deck.
          </p>
        </div>
      </div>
  );
}

export default App;
